import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import config from "../../../../config/apiConfig";
import Loader from "react-spinners/RingLoader";
import { HighlightOff } from "@material-ui/icons";
import black from "../../../../icons/default1.png";
import ReactGA from 'react-ga';

type Props = {
    selectStory: (id: string) => any;
    setTotalStories: (count: number) => any;
};

const StoryList: React.FC<Props> = ({ selectStory, setTotalStories }) => {
    const [scrapbook, setScrapbook] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        handleScrapbook();
    }, []);

    function handleScrapbook() {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        setIsLoading(true);
        fetch(
            config.BASE_URL + "/v1/get/scrapbook/stories?climit=100",
            requestOptions
        )
            .then((response) => response.json())
            .then((resp) => {
                setScrapbook(resp.data);
                setTotalStories(resp.data.length);
            })
            .finally(() => setIsLoading(false));
    }

    function handleDeleteFromScrap(
        e: React.MouseEvent<SVGSVGElement, MouseEvent>,
        id: string
    ) {
        e.stopPropagation();
        ReactGA.event({
            category: 'Scrapbook',
            action: 'Delete from scrapbook',
            label: id,
        });
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(
            config.BASE_URL + "/v1/put/scrapbook/delete?story_id=" + id,
            requestOptions
        )
            .then((response) => response.json())
            .then(() => {
                const data = [...scrapbook];
                const newData = data.filter((story) => story.id !== id);
                setScrapbook([...newData]);
            });
    }

    function handleNoImage(e: any) {
        e.target.src = black;
    }

    if (isLoading) {
        return <Loader color={"pink"} />;
    }

    return (
        <React.Fragment>
            {scrapbook.length > 0
                ? scrapbook.map((story: any) => (
                      <div
                          className="scrap__container"
                          onClick={() => {
                            ReactGA.event({
                                category: 'Scrapbook',
                                action: 'Scrapbook click',
                                label: story.id,
                            });
                              selectStory(story.id);
                          }}
                      >
                          <div className="scrap__left">
                              <img
                                  className="scrap__img"
                                  src={story?.images[0]?.link ?? ""}
                                  onError={handleNoImage}
                              />
                          </div>
                          <div className="scrap__right">
                              <h4 className="scrap__title">{story.title}</h4>
                              <div className="scrap__delete">
                                  <HighlightOff
                                      onClick={(e) =>
                                          handleDeleteFromScrap(e, story.id)
                                      }
                                  />
                              </div>
                          </div>
                      </div>
                  ))
                : null}
        </React.Fragment>
    );
};

export default StoryList;
